

























































import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import { Injectable, Container } from 'ca-middleware';
import MapResolver from '../../util/MapResolver';
@Component({
    name: 'LayoutSearch',
    mixins: [MapResolver],
})
export default class LayoutSearch extends Vue {
    @Injectable() public container!: Container;
    @Prop() public messageDetailData: any;


    public fullscreenLoading: any = false;
    private timeout: any = 0;
    private aroundName: any = '';
    private dealAroundName: any = '';
    private aroundRadius: any = 10000;


    constructor() {
        super();
    }




    // 监听关键词的改变进行建议词搜索
    @Watch('$store.state.searchStore.commonKeyword')
    public async getSearchTip(keyword: string) {
        if (this.$store.state.searchStore.isChangeCommonKeyFlag) {
            this.$store.dispatch('searchStore/isChangeCommonKeyFlagEmit', false);
            return ;
        }

       // 关键字为空的时候
        if (!keyword) {
            this.$store.dispatch('searchStore/isShowPathIconEmit', true);

            const component: any = await this.getComponent();
            component.unload();
           // component.removeBuffer();
           // 关闭结果组件面板
            this.$store.dispatch('searchStore/isShowSearchResultEmit', false);
            // 关闭关键词提示组件面板
            this.$store.dispatch('searchStore/isShowTipPanelEmit', false);
            // 关闭messageDetails的组件面板
            this.$store.dispatch('searchStore/isShowMessageDetailEmit', false);
            return ;
        }
        // 实现input连续输入，只发一次请求
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
            this.getListPOI(keyword);
        }, 300);

    }

    @Watch('$store.state.searchStore.aroundKeyword')
    public async getAroundSearchTip(aroundKeyword: string) {
        if (this.$store.state.searchStore.isChangeAroundKeyFlag) {
            this.$store.dispatch('searchStore/isChangeAroundKeyFlagEmit', false);
            return ;
        }
        if (aroundKeyword === '') {
            const component: any = await this.getComponent();
            component.unload();
            // 关闭结果组件面板
            this.$store.dispatch('searchStore/isShowSearchResultEmit', false);
            // 关闭关键词提示组件面板
            this.$store.dispatch('searchStore/isShowTipPanelEmit', false);
            // 关闭messageDetails的组件面板
            this.$store.dispatch('searchStore/isShowMessageDetailEmit', false);
            return ;
        }



        // 实现input连续输入，只发一次请求
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
            this.getAroundListPOI(aroundKeyword);
        }, 300);

    }


    /**
     * poi建议搜索列表
     */
    public async getListPOI(keywords: string) {
        try {
            if (this.$store.state.searchStore.commonKeyword === keywords) { // 关键代码 避免先请求后返回问题，确保给列表赋值是以当前输入的值为参数的
                const component: any = await this.getComponent('Toolbar', 'RegeoCode');
                const searchComp: any = await this.getComponent();
                // 接入真实数据
                component.regeocode().then((result: any) => {
                    const opt = {
                        keyword: this.$store.state.searchStore.commonKeyword,
                        query_type: 1,
                        region: result,
                    };
                    searchComp.keywordSearch(opt).then((suggest: any) => {
                        this.$emit('getTipPanelDatas', suggest);
                    });
                });

            }
        } catch (err) {
            console.log('建议词查询列表接口请求失败', err);
        }

    }

    /**
     * poi建议搜索列表
     */
    public async getAroundListPOI(aroundKeyword: string) {
        try {
            if (this.$store.state.searchStore.aroundKeyword === aroundKeyword) { // 关键代码 避免先请求后返回问题，确保给列表赋值是以当前输入的值为参数的

                const component: any = await this.getComponent();
                // 接入真实数据
                const location = this.messageDetailData.data.location.x + ',' + this.messageDetailData.data.location.y;
                const region = this.messageDetailData.data.city ? this.messageDetailData.data.city : '1';
                const opt = {
                    keyword: this.$store.state.searchStore.aroundKeyword,
                    query_type: 1,
                    location,
                    region,
                };

                component.aroundSearch(opt).then((suggest: any) => {
                    this.$emit('getTipPanelDatas', suggest);
                });

            }
        } catch (err) {
            console.log('周边建议词查询列表接口请求失败', err);
        }

    }

    // poi搜索
    public async handleClickSearch() {
        if (!this.$store.state.searchStore.commonKeyword) {
            return;
        }
        // 隐藏路径规划logo
        this.$store.dispatch('searchStore/isShowPathIconEmit', false);
        // 关闭关键词提示组件面板
        this.$store.dispatch('searchStore/isShowTipPanelEmit', false);
        // 关闭messageDetails的组件面板
        this.$store.dispatch('searchStore/isShowMessageDetailEmit', false);


        try {
            // 加载地图组件
            const component: any = await this.getComponent('Toolbar', 'RegeoCode');
            const searchComp: any = await this.getComponent();
            searchComp.unload();

            component.regeocode().then((result: any) => {
                const opt = {
                    keyword: this.$store.state.searchStore.commonKeyword,
                    query_type: 2,
                    region: result,
                };
                searchComp.keywordSearch(opt).then((dataList: any) => {
                    this.$emit('searchResultDatasEmit', dataList);
                    // 这里点击后虽然普通关键词变化了，但是不用重新查
                    // this.$store.dispatch('searchStore/isChangeCommonKeyFlagEmit', true);
                });
            });


        } catch (err) {
            console.log('关键字查询列表接口请求失败', err);
        }
    }



    private async getAroundListDatas() {
        // 加载地图组件
        const searchComp: any = await this.getComponent();
        // 接入真实数据
        if (this.$store.state.searchStore.isShowRoundFlag) {
            const location = this.messageDetailData.data.location.x + ',' + this.messageDetailData.data.location.y;
            const region = this.messageDetailData.data.city ? this.messageDetailData.data.city : '1';
            const opt = {
                keyword: this.$store.state.searchStore.aroundKeyword,
                query_type: 2,
                location,
                region,
                radius: this.aroundRadius,
            };
            searchComp.aroundSearch(opt).then((dataList: any) => {
                this.$emit('searchResultDatasEmit', dataList);
            });
        }

    }

    // 路径规划
    private  pathClickSearch() {
        // 关闭关键词提示组件面板
        this.$store.dispatch('searchStore/isShowTipPanelEmit', false);
        this.$emit('showPathPanelEmit');
    }





    // 监听是否开启周边搜索
    @Watch('$store.state.searchStore.aroundName')
    private openRoundSearch(val: any) {
        if (val === '') {
            return;
        }
        if (val.length > 4) {
            this.dealAroundName = val.slice(0, 4) + '...';
        } else {
            this.dealAroundName = val;
        }
    }

    // 周边搜索
    private async handleClickAroundSearch() {
        if (!this.$store.state.searchStore.aroundKeyword) {
            return;
        }
        const component: any = await this.getComponent();
        component.unload();

        // 关闭关键词提示组件面板
        this.$store.dispatch('searchStore/isShowTipPanelEmit', false);
        // 关闭messageDetails的组件面板
        this.$store.dispatch('searchStore/isShowMessageDetailEmit', false);

        // 添加遮盖层
        this.fullscreenLoading = true;
        setTimeout(() => {
            this.fullscreenLoading = false;
        }, 200);


        try {
            const component: any = await this.getComponent();
            // 接入真实数据
            const location = this.messageDetailData.data.location.x + ',' + this.messageDetailData.data.location.y;
            const region = this.messageDetailData.data.city ? this.messageDetailData.data.city : '1';
            const opt = {
                keyword: this.$store.state.searchStore.aroundKeyword,
                query_type: 2,
                location,
                region,
            };
            component.aroundSearch(opt).then((dataList: any) => {
                this.$emit('searchResultDatasEmit', dataList);
            });
        } catch (err) {
            console.log('周边查询列表接口请求失败', err);
        }
    }

    // 关闭周边搜索 展开细节面板
    private async closeRoundSearch() {
        if (this.$store.state.searchStore.aroundKeyword) {
            this.$store.dispatch('searchStore/aroundKeywordEmit', '');
            const component: any = await this.getComponent();
            component.unload();
            // 关闭结果组件面板
            this.$store.dispatch('searchStore/isShowSearchResultEmit', false);
        } else {
            this.$store.dispatch('searchStore/aroundNameEmit', '');
            this.$store.dispatch('searchStore/isShowRoundFlagEmit', false);
            // 恢复messageDetails的组件面板
            this.$store.dispatch('searchStore/isShowMessageDetailEmit', true);
            // 重新刷新地图点的标志
            this.$store.dispatch('searchStore/refreshMapPointFlagEmit', true);

        }



    }

    private async created() {
        const component: any = await  this.getComponent();
        component.on('popup', this.onPopup, this);
        component.off('buffer_radius_change');
        component.on('buffer_radius_change', (val: any) => {
            this.aroundRadius = val;
            this.getAroundListDatas();
        });

        $(window).keydown((ev: any) => {
            const event = ev || window.event;
            // 回车
            if (event.keyCode === 13) {
                if (this.$store.state.searchStore.isShowRoundFlag) {
                    this.handleClickAroundSearch();
                } else {
                    this.handleClickSearch();
                }
            }
        });

    }

    private onPopup(data: any) {
        const div = '<div style="padding: 0 5px; height: 30px;display: table-cell;vertical-align: middle;background: #FFF;border-radius: 5px; text-align:center;" >' +
            '<div style="    font-size: 12px;font-weight: 700;word-wrap: break-word;overflow: hidden;display: block;">{{text}}</div>' +
            '</div>';
        const instance: any = new Vue({
            el: '#' + data.containerId,
            template: div,
            data: () => {
                return {
                    text: data.data.name,
                };
            },
        });
        // 点击散点，展现详情信息，同时高亮
        if (data.containerId === 'popup_search_comp') {
            // 关闭结果组件面板
            this.$store.dispatch('searchStore/isShowSearchResultEmit', false);
            // 发射该条数据到附近信息面板
            this.$emit('messageDetailDataEmit', {data: data.data});
        }
    }

    private getComponent(moduleName: string = 'Search', componentName: string = 'POISearch') {
        const p = new Promise((resolve, reject) => {
            (this as any).resolveMap('map').then((data: any) => {
                const temp: any = this;
                const facotory = temp.container.resolve('mapShare').comFactory;
                const component = facotory.getComponent(moduleName, componentName);
                resolve(component);
            }).catch(() => { reject('获取地图组件失败'); });
        });
        return p;
    }

}
